import axios from '../../axiosInstances/axiosInstance';

export const getMyFavorites = () => {
  return axios.get(`/users/favoriteOrders`);
};
